import { formatMoney } from '@betterment/core';
import { format } from 'date-fns';

import { ForecasterProjectionChart } from '../../../../shared/components/ForecasterProjectionChart';
import { ProjectionHighlight } from '../../../../shared/components/ProjectionHighlight';
import { Disclosures, PurposeRetirementGrowth } from '../../../data';

type Props = {
  purpose: PurposeRetirementGrowth;
  disclosures: Disclosures;
};

export const RetirementGrowthProjection = ({ disclosures, purpose }: Props) => {
  const projection = purpose.retirementGrowthProjection;
  if (!projection) return null;

  const timeSeries = projection?.balanceTimeSeries;
  const finalPoint = timeSeries[timeSeries.length - 1];
  const targetAmount = purpose.retirementGrowthProjection?.completion?.targetTotalSpendingAmount;

  return (
    <ForecasterProjectionChart targetAmount={targetAmount} disclosures={disclosures} timeSeries={timeSeries}>
      <ForecasterProjectionChart.Header>
        <ProjectionHighlight
          title="Projected balance"
          value={formatMoney(finalPoint.expected)}
          subtitle={format(finalPoint.date, 'MMM yyyy')}
        />
        {targetAmount && (
          <ProjectionHighlight
            title="Savings target"
            value={formatMoney(targetAmount)}
            subtitle="Calculated from spending power"
          />
        )}
      </ForecasterProjectionChart.Header>
    </ForecasterProjectionChart>
  );
};
